// extracted by mini-css-extract-plugin
export var introTextContainer = "TermsAndConditionsModal-module--introTextContainer--200a2";
export var modal = "TermsAndConditionsModal-module--modal--b9ec2";
export var modalContentContainer = "TermsAndConditionsModal-module--modalContentContainer--92106";
export var modalText = "TermsAndConditionsModal-module--modalText--93394";
export var title = "TermsAndConditionsModal-module--title--b705c";
export var titleDivider = "TermsAndConditionsModal-module--titleDivider--0f03a";